var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-links"},[(!_vm.isHealthCare)?_c('router-link',{attrs:{"to":"/food"}},[_vm._v("Food")]):_vm._e(),_vm._l((_vm.paths),function(path,i){return _c('span',{key:i},[_vm._v(" > "),_c('router-link',{class:{
        'font-weight-bold': path === _vm.paths[_vm.paths.length - 1] ? true : false,
      },attrs:{"to":_vm.urls[i]}},[_vm._v(_vm._s(path))])],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }